import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-white border-t border-slate-200 mt-20">
    <div className="max-w-7xl mx-auto px-5 py-10">
      <div className="flex flex-col lg:flex-row gap-6 lg:items-start lg:justify-between">
        <div>
          <p className="font-semibold text-slate-800">© 2026 Vagas Campinas e Região</p>
          <p className="text-slate-600 text-sm mt-2">Responsável pela plataforma: Miguel Augusto.</p>
          <a href="mailto:miguelyxrecords@gmail.com" className="text-blue-700 font-bold text-sm mt-2 inline-flex items-center gap-2">
            <Mail size={15} /> miguelyxrecords@gmail.com
          </a>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-3 text-sm font-bold text-slate-700">
          <Link to="/sobre" className="hover:text-blue-700">Sobre</Link>
          <Link to="/seguranca" className="hover:text-blue-700">Segurança</Link>
          <Link to="/termos" className="hover:text-blue-700">Termos de Uso</Link>
          <Link to="/privacidade" className="hover:text-blue-700">Privacidade</Link>
          <Link to="/reembolso" className="hover:text-blue-700">Cancelamento e Reembolso</Link>
        </nav>
      </div>
      <div className="border-t border-slate-100 mt-7 pt-6 text-slate-500 text-sm">
        Grátis para candidatos. Nunca pague para garantir entrevista ou contratação. Confira sempre os dados da empresa antes de enviar documentos.
      </div>
    </div>
  </footer>
);
